var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"version_record"},[_c('div',{staticClass:"version-list"},_vm._l((_vm.list),function(item,index){return _c('van-cell',{key:index,attrs:{"title":'V'+item.name,"is-link":"","to":'version/details?id='+item.id}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }